<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['close', 'error']);

const props = defineProps({
  token: {
    type: String,
    required: true,
  }
})

const handleCopy = () => {
  navigator.clipboard.writeText(props.token);
}
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal @close="emit('close')">
      <div>
        <h2 class="tw-text-2xl tw-text-center tw-font-bold">
          API Key Generated
        </h2>

        <p class="tw-mt-4 tw-text-center tw-text-lg">
          Please make a note of your API Key,
          <br>as this is the only time it will be shown to you in full.
        </p>

        <div class="tw-mx-auto tw-my-3 tw-flex tw-justify-center">
          <span class="tw-font-bold tw-text-neutral-900 tw-text-lg tw-bg-neutral-100 tw-px-[20px] tw-py-[10px] tw-rounded">
            {{ token }}
          </span>
          <span
            class="copy-btn"
            @click="handleCopy"
          >
            <svg-vue
              class="svg"
              icon="icons/copy-simple"
            />
          </span>
        </div>
        <div class="tw-w-100 tw-flex tw-justify-center tw-mt-4">
          <DefaultButton
            @click="$emit('close')"
          >
            Confirm
          </DefaultButton>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>

<style scoped>

.copy-btn {
  display: flex;
  width: 50px;
  height: 50px;
  padding: 2px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 0 8px 8px 0;
  background: #DFDFDF;
  cursor: pointer;
}

.copy-btn:hover {
  background: #b5b4b4;
  transition: all 0.5s ease;
}

.svg {
  width: 24px;
}
</style>
